import ButtonBordered from "src/components/shared/Button/ButtonBordered";
import styled, { css } from "styled-components";
import { ReactComponent as Bird } from "../../images/nerdy-bird.svg";

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  width: 100%;
  max-width: 448px;
  min-height: 600px;
  padding-top: 56px;
  padding-bottom: 56px;

  h1 {
    font-size: ${({ theme }) => theme.fonts.sizes.m};
    text-align: center;
  }

  @media ${({ theme }) => theme.mq.md} {
    h1 {
      font-size: ${({ theme }) => theme.fonts.sizes.xl};
    }
  }
`;

export const Stepper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 24px;

  p {
    margin-right: 10px;
    font-weight: bold;
  }

  @media ${({ theme }) => theme.mq.md} {
    margin-top: 48px;
    p {
      font-size: ${({ theme }) => theme.fonts.sizes.s};
    }
  }
`;

export const Step = styled.div<{ active: boolean; clickable?: boolean }>`
  font-family: "Inconsolata";
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 2px solid ${({ theme }) => theme.colors.primary};
  text-align: center;
  font-size: ${({ theme }) => theme.fonts.sizes.base};
  line-height: 20px;
  cursor: ${({ clickable }) => (clickable ? "pointer" : "auto")};

  @media ${({ theme }) => theme.mq.md} {
    width: 32px;
    height: 32px;
    font-size: ${({ theme }) => theme.fonts.sizes.s};
    line-height: 28px;
  }

  ${({ active }) =>
    active &&
    css`
      color: ${({ theme }) => theme.colors.background};
      background-color: ${({ theme }) => theme.colors.primary};
    `}
`;

export const StepSeparator = styled.div`
  width: 16px;
  border-top: 2px solid ${({ theme }) => theme.colors.primary};

  @media ${({ theme }) => theme.mq.md} {
    width: 24px;
  }
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  margin-top: 48px;
`;

export const Spectator = styled.div`
  display: flex;
  justify-content: space-between;
  padding-bottom: 15px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.primary};
`;

export const NextStepButton = styled(ButtonBordered)`
  width: 100%;
  margin-top: 72px;
`;

export const FloatingNerdyBird = styled(Bird)`
  display: none;
  position: fixed;
  right: 0;
  bottom: -45px;
  z-index: -1;

  @media ${({ theme }) => theme.mq.md} {
    display: inline;
  }
`;

export const FirstStepWrapper = styled.div`
  & > *:not(:first-child) {
    margin: 20px 0;
  }
  & > *:nth-child(2) {
    margin-top: 0;
  }
  & > *:nth-child(3) {
    margin-top: calc(8px + var(--lh-xs));
  }
`;
